<template>
  <div class="productlist mobile-product" :id="product && 'productlist-' + product.id" :style="cardStyle">
    <router-link :to="'/product/' + this.urlKey + '?gte' + '=' + (this.genderType || 0)">
    <div
      @click="trigerEvent(index, parry, productCat, renderName, callerComp)"
      :class="'listhover ' + pclass"
      class="d-inline-block w-100 custom-border"
      v-lazyloadImage="{...getTatvicprImpression}"
    >
      <img
        fallback="https://prod-img.thesouledstore.com/static/blankimg.jpg"
        :placeholder="'https://prod-img.thesouledstore.com/static/blankimg.jpg'"
        v-imageBackground="isBlockMounted ? '1080:1440' : ''"
        :blur="30"
        class="customFade w-100 img-auto"
        :data-url="parry"
        :alt="`${productTitle} ${listCat} Online`"
        :title="`${productTitle} ${listCat} at The Souled Store`"
        width="355" height="280"
      />
      <div class="mockup-tag" :class="getMockUpTagPositionClass(mockUpTag.tag_position)" v-for="mockUpTag in plpMockUpTags" :key="mockUpTag.product_slug">
        <span
        v-if="mockUpTag.product_slug === urlKey && mockUpTag.is_active_plp"
        v-bind:style="{backgroundColor: mockUpTag.background_color, color: mockUpTag.text_color}"
        >{{mockUpTag.tag_name}}</span>
      </div>
    <!-- </router-link> -->
  </div>
</router-link>
    <div class="image-block-details" :class="{'height-membership': isExclusive}">
      <h5 class="text-left">{{ productTitle }}</h5>
      <div class="row">
        <div class="col-12 listprice ecltext" style="padding-right:0px;" :title="productCat">
          <span v-if="listCat">{{ listCat }}</span>
          <span v-else>{{ productCat }}</span>
        </div>
        <div class="col-12" style="padding-right:0px;" v-if="productPrice">
          <span v-if="getround(spprice) || (isExclusive && getround(exclusivePrice))">
            <div class="row">
              <div class="col-12 special-products_pricing">
                <span class="offer fsemibold">{{ currencySymbol }} {{ isExclusive ? exclusivePrice && getround(exclusivePrice) : spprice && getround(spprice) }}</span>
                <span
                  class="product-price"
                  style="text-decoration: line-through; color:#757575;"
                >{{ currencySymbol }} {{productPrice && getround(productPrice) }}</span>
                  <span
                    class="percentage-off"
                    v-if="!isExclusive && spprice > 0"
                  >
                 
                  <span v-if="isNonExclusiveSavingsInPercent">{{`${Math.round((productPrice - (isExclusive ? exclusivePrice : spprice)) / productPrice * 100)}%`}} {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}</span>
                  <span v-else>{{ currencySymbol }} {{`${(getround(productPrice) - getround(spprice))}`}} {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}</span>
                  </span>
              </div>
            </div>
          </span>
          <span v-else>{{ currencySymbol }} {{ productPrice && getround(productPrice) }}</span>
          <div class="mrp-text" v-if="showPriceInclusiveOnHome && isSelectedCountryIndia">{{ showPriceInclusiveOnHome.tag_text }}</div>
          <div class="mrp-text" v-if="showMrpOnHomeGlobal && !isSelectedCountryIndia">{{ showMrpOnHomeGlobal.tag_text }}</div>
        </div>
        <div class='col-12 percentage-off member-savings' v-if="getround(exclusivePrice) && getround(productPrice) && isExclusive">
          <span v-if="isExclusiveSavingsInPercent">{{getround((getround(productPrice) - getround(exclusivePrice)) / getround(productPrice) * 100)}}% {{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}}</span>
          <span v-else>{{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}} {{ currencySymbol }} {{getround(productPrice) - getround(exclusivePrice)}}</span>
        </div>
        <div v-if="bannerPlaceHolderForGstInclusiveLabel && Object.keys(bannerPlaceHolderForGstInclusiveLabel).length" class="col-12 gstInclusiveLabel">
          <span :style="`color: ${bannerPlaceHolderForGstInclusiveLabel.banner_text_color}; background: ${bannerPlaceHolderForGstInclusiveLabel.banner_color};`">{{bannerPlaceHolderForGstInclusiveLabel.tag_text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {getProductUrl} from '../../assets/js/common'
import getLastPage from '../../assets/js/getLastPage'
import Vue from 'vue'
export default {
  props: {
    parry: String,
    urlKey: String,
    imageH: Number,
    imageW: Number,
    product: Object,
    productTitle: String,
    productCat: String,
    productPrice: '',
    pstock: Number,
    spprice: '',
    position: Number,
    exclusivePrice: '',
    pclass: String,
    listCat: String,
    isStockConfig: Number,
    prodType: Number,
    isExclusive: Boolean,
    togglePopup: Function,
    souledout: Boolean,
    jitValue: String,
    scrollToProduct: Function,
    plpMockUpTags: Array,
    genderType: Number,
    index: Number,
    cardStyle: [String, Object],
    renderName: String,
    callerComp: String,
    widgetType: String,
    isWidgetProduct: Boolean
  },
  data () {
    return {
      EXCLUSIVE_PRODUCT: process.env.EXCLUSIVE_PRODUCT,
      isBlockMounted: false
    }
  },
  mounted () {
    this.isBlockMounted = true
  },
  methods: {
    getMockUpTagPositionClass: function (mockUpTagPosition) {
      switch (mockUpTagPosition) {
        case 'BOTTOM_LEFT':
          return 'mockup-tag-bottom-left'
        case 'BOTTOM_RIGHT':
          return 'mockup-tag-bottom-right'
        case 'TOP_LEFT':
          return 'mockup-tag-top-left'
        case 'TOP_RIGHT':
          return 'mockup-tag-top-right'
        default:
          return ''
      }
    },
    trigerEvent: function (index, parry, productCat, renderName, callerComp) {
      Vue.ls.set('widget_click_position', {route: getLastPage(this.$route.name), name: this.renderName || this.callerComp || ''})
      const gender = Vue.ls.get('tss_landingCategory')
      let slide = {
        'index': index,
        'images': parry,
        'category': productCat === 'Exclusive' ? 'Exclusive' : 'Product',
        'renderName': renderName,
        'callerComp': callerComp && callerComp.length ? callerComp : '',
        'productName': this.productTitle,
        'productCategory': this.listCat ? this.listCat : this.productCat
      }
      let obj = {}
      let localPayload = {...this.getTatvicprImpression}
      if (localPayload && localPayload.searchTerm && localPayload.searchTerm.length) {
        obj.SEARCH_TERM = localPayload.searchTerm
        delete localPayload.searchTerm
      }
      this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'select_item',
        payload: {
          'items': [
            localPayload
          ],
          ...obj
        }
      })
      if (productCat === 'Exclusive') {
        this.$router.push('/membership')
      } else {
        this.$router.push('/product/' + this.urlKey + '?gte' + '=' + (this.genderType || 0))
      }
      this.$store.commit('GTAG_EVENT', {eventName: slide.renderName === 'New Arrivals' ? slide.callerComp + '_new_arrivals' : slide.callerComp + '_top_selling',
        payload: {
          slider_index: slide.index,
          category: slide.category,
          imageURL: slide.images,
          productName: slide.productName,
          productCategory: slide.productCategory
        }}
      )
      this.$store.commit('SET_NAVIGATION_WIDGET', this.renderName || this.widgetType)
      const widgetClickPosition = Vue.ls.get('widget_click_position') || {}
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'WIDGET-CLICK',
        payload: {
          Section_Name: this.renderName || '',
          Section_Index: index,
          Product_Category: this.listCat || '',
          Product_Name: this.productTitle || '',
          Product_ID: (this.product && this.product.id) || '',
          Product_Price: this.exclusivePrice || this.spprice ? this.isExclusive ? this.exclusivePrice : this.spprice : this.productPrice,
          Product_Artist: this.productCat,
          ProductImage_URL: parry,
          Product_URL: this.getProductUrl(true, this.urlKey, this.genderType),
          GENDER: gender,
          widget_name: this.renderName && this.renderName.toLowerCase(),
          widget_click_position: widgetClickPosition && widgetClickPosition.route,
          widget_current_route: getLastPage(this.$route.name)
        }}
      )
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-SECTION',
        payload: {
          Section_Name: this.renderName || '',
          Section_Index: index,
          Product_Category: this.listCat || '',
          Product_Name: this.productTitle || '',
          Product_ID: (this.product && this.product.id) || '',
          Product_Price: this.exclusivePrice || this.spprice ? this.isExclusive ? this.exclusivePrice : this.spprice : this.productPrice,
          Product_Artist: this.productCat,
          ProductImage_URL: parry,
          Product_URL: this.getProductUrl(true, this.urlKey, this.genderType),
          GENDER: gender,
          widget_name: this.renderName && this.renderName.toLowerCase(),
          widget_click_position: widgetClickPosition && widgetClickPosition.route,
          widget_current_route: getLastPage(this.$route.name)
        }}
      )
      if (this.isWidgetProduct) {
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-WIDGET-SECTION',
          payload: {
            Collection_Name: this.renderName || 'NA',
            Widget_Name: this.renderName === 'Continue where you left from' ? 'Keep exploring' : this.renderName || 'NA',
            isLoggedIn: this.authStatus,
            UserId: this.user && this.user.user_id ? this.user.user_id : 'NA',
            UserFirstName: this.user && this.user.firstname ? this.user.firstname : 'NA',
            UserLastName: this.user && this.user.lastname ? this.user.lastname : 'NA',
            UserEmail: this.user && this.user.email ? this.user.email : 'NA',
            Product_Category: this.listCat || 'NA',
            Product_Name: this.productTitle || 'NA',
            Product_ID: (this.product && this.product.id) || '',
            Product_Price: this.exclusivePrice || this.spprice ? this.isExclusive ? this.exclusivePrice : this.spprice : this.productPrice,
            Product_Artist: this.productCat,
            ProductImage_URL: parry,
            Product_URL: this.getProductUrl(true, this.urlKey, this.genderType),
            Platform: 'WEB'
          }}
        )
      }
    },
    getround: function (val) {
      return parseInt(val)
    },
    removeChar (str) {
      var b
      if (str) {
        b = str.slice(0, -1)
      } else {
        b = str
      }
      return b
    },
    formatTime: function (date) {
      let d = date ? new Date(date) : new Date()
      return (
        [
          d.getFullYear(),
          ('0' + (d.getMonth() + 1)).slice(-2),
          ('0' + d.getDate()).slice(-2)
        ].join('-') +
        ' ' +
        [
          ('0' + d.getHours()).slice(-2),
          ('0' + d.getMinutes()).slice(-2),
          ('0' + d.getSeconds()).slice(-2)
        ].join(':')
      )
    },
    getProductUrl
  },
  computed: {
    ...mapGetters({bannerPlaceHolderData: 'bannerPlcaeHolderData', memberSavingsTxt: 'memberSavingsTxt', nonMemberSavingsTxt: 'nonMemberSavingsTxt', authStatus: 'authStatus', currencySymbol: 'currencySymbol', isSelectedCountryIndia: 'isSelectedCountryIndia', user: 'user'}),
    showPriceInclusiveOnHome: function () {
      return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
      bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_INC_OF_TEX_TEXT_HOME_WEB')
    },
    showMrpOnHomeGlobal () {
      return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
      bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GLOBAL_MRP_TEXT_HOME_WEB')
    },
    showExclusive: function () {
      return (
        this.exclusivePrice &&
        !this.isExclusive &&
        this.exclusivePrice < this.productPrice &&
        ((this.spprice && this.exclusivePrice < this.spprice) || !this.spprice)
      )
    },
    isExclusiveSavingsInPercent: function () {
      const excSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
        bannerData.product_type.toLowerCase() === 'SHOW_EXC_SAVING_PERCENT_PLP'.toLowerCase())
      return excSavingsInPercent
    },
    isNonExclusiveSavingsInPercent: function () {
      const noExcSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true &&
        bannerData.product_type.toLowerCase() === 'NO_EXC_SAVING_PERCENT_HOME_WEB'.toLowerCase())
      return noExcSavingsInPercent
    },
    getTatvicprImpression () {
      const widgetClickPosition = Vue.ls.get('widget_click_position') || {}
      return {
        item_name: (this.product && this.product.product_name) || '',
        item_id: this.product && (this.product.id || this.product.prod_id),
        price: this.getProductPrice,
        item_category: this.product && this.product.category && this.product.category.name || this.productCat || this.product.product_type,
        item_list_name: this.renderName ? this.renderName : 'NA',  // item list name for eg, search results, category page, similar products, top selling
        index: this.index,
        image_url: String(this.baseImgPath + this.path + (this.parry && this.parry[0])),
        image_arr: String(this.baseImgPath + this.path + (this.parry && this.parry[0])) && String(this.baseImgPath + this.path + (this.parry && this.parry[0])).split('?'),
        image_name: String(this.parry && this.parry[0]),
        currency: 'INR',
        item_brand: 'The Souled Store',
        discount: this.spprice > 0 || (this.exclusivePrice > 0 && this.isExclusive) ? this.getround(this.productPrice) - this.getround(((this.isExclusive ? this.exclusivePrice : this.spprice) || 0)) : 0,
        widget_name: this.renderName && this.renderName.toLowerCase(),
        widget_click_position: widgetClickPosition && widgetClickPosition.route,
        widget_current_route: getLastPage(this.$route.name)
      }
    },
    getMoengageImpressionData () {
      if (this.product) {
        return {
          item_artist: this.productCat,
          item_url: window.location.origin + '/product/' + this.urlKey + '?gte' + '=' + (this.genderType || 0),
          item_image_url: this.parry,
          plp_url: window.location.origin + this.$route.path
        }
      }
    },
    getProductPrice () {
      if (this.getround(this.spprice) || (this.isExclusive && this.getround(this.exclusivePrice))) {
        return this.isExclusive ? this.exclusivePrice && this.getround(this.exclusivePrice) : this.spprice && this.getround(this.spprice)
      } else {
        return this.productPrice && this.getround(this.productPrice)
      }
    },
    bannerPlaceHolderForGstInclusiveLabel: function () {
      const isGstInclusiveLabelObj = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GST_INCLUSIVE_LABEL_TOPSELLING'.toLowerCase())
      if (isGstInclusiveLabelObj) {
        return isGstInclusiveLabelObj
      }
      return null
    }
  }
}
</script>
<style scoped>
.image-block-details {
  padding:0px 5px 0px 10px;
}
.height-membership {
  min-height: 5.2rem;
}
.productlist{
  background-color: white;
  /* padding-bottom: 10px;  */
}
.offer {
  color: #58595b;
  margin-right: 5px;
}
.product-price {
  font-size: 14px;
}
.ex-price {
  font-size: 14px;
  color: #3498db;
}
.fa-info-circle {
  margin-left: 2px;
}
.fa-info-circle:before {
  font-size: 12px;
}
.percentage-off {
  margin-left: 5px;
  font-size: 14px;
  color: #D34222;
}
.member-savings {
  margin-left: unset;
}
.mockup-tag {
  position: absolute;
  text-transform: uppercase;
  top: 25px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  width: 5.1rem;
  text-align: center;
}
.mockup-tag span {
  width: 100%;
  padding: 0px 8px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.mockup-tag-top-left {
  top: 25px;
}
.mockup-tag-top-right {
  top: 25px;
  right: 0;
}
.mockup-tag-top-right span {
  border-radius: unset;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.mockup-tag-bottom-left {
  top: unset;
  bottom: 25px;
}
.mockup-tag-bottom-right {
  top: unset;
  bottom: 25px;
  right: 0;
}
.mockup-tag-bottom-right span {
  border-radius: unset;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.gstInclusiveLabel {
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .mockup-tag {
    top: 19px;
    font-size: 9px;
    width: 4.5rem;
  }
  .mockup-tag-top-left {
    top: 19px;
  }
  .mockup-tag-top-right {
    top: 19px;
    right: 0;
  }
  .mockup-tag-bottom-left {
    top: unset;
    bottom: 19px;
  }
  .mockup-tag-bottom-right {
    top: unset;
    bottom: 19px;
    right: 0;
  }
  .mockup-tag span {
    width: 100%;
    padding: 0px 6px;
  }
  .mobile-product {
    border-radius: 5px;
    border: 1px solid #f2f2f2;
    margin-bottom: 1.3rem;
  }
  .mobile-product img{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .custom-border{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
}
@media screen and (max-width: 1024px) {
  .percentage-off {
    font-size: 12px;
  }
  .special-products_pricing {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

@media screen and (max-width: 1024px) {
  .special-products_pricing {
    padding-left: 5px !important;
    padding-right: 0px !important;
  }
}
@media screen and (max-width: 480px) {
  .ex-price {
    font-size: 11px;
  }
  .gstInclusiveLabel {
    font-size: 12px;
  }
}
@media screen and (max-width: 480px) {
  .fa-info-circle {
    margin-left: 0;
  }
  .percentage-off {
    font-size: 12px;
  }
  .offer {
    font-size: 12px;
  }
  .product-price {
    font-size: 12px;
  }
}
@media (min-width: 1200px) {
  .productlist {
    margin-bottom: 0px !important;
  }
}
@media screen and (max-width: 400px) {
  .percentage-off {
    font-size: 11px;
  }
}
@media screen and (max-width: 320px) {
  .percentage-off { 
    font-size: 9px;
  }
  .offer {
    font-size: 10px;
  }
  .product-price {
    font-size: 10px;
  }
}
.coming-soon {
  background: green;
  color: #fff;
  position: absolute;
  text-transform: uppercase;
  top: 10px;
  padding: 5px 20px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.product-image-container {
  position: relative;
  text-align: center;
}

.product-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-in-out {
  animation: fadeInOut ease 3s infinite;
  -webkit-animation: fadeInOut ease 3s infinite;
  -moz-animation: fadeInOut ease 3s infinite;
  -o-animation: fadeInOut ease 3s infinite;
  -ms-animation: fadeInOut ease 3s infinite;
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@-moz-keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@-o-keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@-ms-keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
.mrp-text {
  color: #888;
}
</style>



// WEBPACK FOOTER //
// TopSellingImgBlock.vue?5f4bdec8